import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { WarningTelemetry } from "./WarningTelemetry";
import { FlightStatus, Sim } from "../features/aircraft/types";
import { Connection } from "../features/aircraft/aircraftSlice";

type Props = {
  connection: Connection;
  stale?: boolean;
};

const getSimError = (sim: Sim) => {
  if (!sim?.available) return `${sim.status}`;
  if (!sim?.active) return `${sim.status}`;
  return "OK";
};

export const WarningTelemetryList = ({
  connection, stale
}: Props) => {
  const [showStaleWarning, setShowStaleWarning] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    if (stale) {
      timer = setTimeout(() => setShowStaleWarning(true), 35000); // 35 + 10stale = 45s (non critical stale state notification time)
    } else {
      setShowStaleWarning(false);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [stale]);

  const connectionWarning = (
    connection: Connection,
  ): {
    message: string;
    type: "danger" | "warning" | "info";
    value: string;
  } | null => {
    if (showStaleWarning) {
      return {
        message: "No telemetry",
        type: "warning",
        value: " - ",
      };
    }
    return null;
  };

  const connectionWarningMessage = connectionWarning(connection);

  if (!connectionWarningMessage) return null;
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }} py={2}>
      {connectionWarningMessage ? (
        <WarningTelemetry
          name="Connection"
          value={``}
          warning={connectionWarningMessage}
        />
      ) : null}
    </Box>
  );
};
